// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { InformationsComponent } from './informations.component';
import { AddressModule } from "libraries/component/address/address.module";
import { TelephoneModule } from "libraries/component/telephone/telephone.module";

@NgModule({
    imports: [
        CommonModule,
        AddressModule,
        TelephoneModule,
    ],
    exports: [
        InformationsComponent,
    ],
    declarations: [
        InformationsComponent,
    ],
    providers: [],
})
export class InformationsModule { }
